import { createContext, useContext, useState, type Dispatch, type SetStateAction } from 'react';

export interface ActiveSlide {
  /** The expanded slide card, null when all are collapsed. */
  active: number | null;
  setActive: Dispatch<SetStateAction<number | null>>;
}

/**
 * Provided by BlockEditor so the slide list and the preview share one current slide: expanding a
 * card shows that slide in the preview, stepping through the preview expands the card.
 */
export const ActiveSlideContext = createContext<ActiveSlide | null>(null);

/** The editor's shared current slide, or local state when rendered outside BlockEditor. */
export function useActiveSlide(): ActiveSlide {
  const shared = useContext(ActiveSlideContext);
  const [active, setActive] = useState<number | null>(0);
  return shared ?? { active, setActive };
}
